import Qs from "qs";
import { decamelize } from "humps";

const PARAMETER_NAME = "orderBy";

/**
 * Create a function to update the URL to handle sorting by an interaction metric in a given direction.
 * @param direction Which direction to sort.
 * @returns         Function to update the URL.
 */
const updateSortUrl = (direction: "asc" | "desc") => (
    queryParameterPrefix: string | undefined,
    property: string,
    search: string
) => {
    const current = Qs.parse(search, { ignoreQueryPrefix: true });
    const orderByName = getParameterName(queryParameterPrefix);
    const parameters = { ...current, [orderByName]: decamelize(`${property}.${direction}`) };
    return { search: Qs.stringify(parameters, { addQueryPrefix: true }) };
};

/**
 * Update the URL when the user sorts ascending.
 */
export const updateSortAscendingUrl = updateSortUrl("asc");

/**
 * Update the URL when the user sorts descending.
 */
export const updateSortDescendingUrl = updateSortUrl("desc");

/**
 * Remove existing sort parameter from the URL.
 * @param search Current query search string.
 * @returns      Updated URL.
 */
export const clearSortUrl = (queryParameterPrefix: string | undefined, search: string) => {
    const current = Qs.parse(search, { ignoreQueryPrefix: true });
    const { [getParameterName(queryParameterPrefix)]: orderBy, ...otherParameters } = current;
    return { search: Qs.stringify({ ...otherParameters }) };
};

/**
 * Maybe combine the query parameter with a prefix.
 * @param queryParameterPrefix Optional prefix for the parameter.
 * @returns                    Combined prefix and name.
 */
const getParameterName = (queryParameterPrefix: string | undefined) => {
    return typeof queryParameterPrefix === "string" ? `${queryParameterPrefix}.${PARAMETER_NAME}` : PARAMETER_NAME;
};
